import { inactiveFilter, isActiveFilter, IsNotSoldFilter, IsSoldFilter } from './Filter.constants';
import { CURRENT_USER_ROUTE_UUID } from './constants';
import USER_ROLES from './UserRoles';

const PRODUCTS_CONFIG = {
  title: 'Products',
  titleId: 'navbar.groupTitle.products',
  pages: [
    {
      title: 'All Products',
      titleId: 'navbar.link.allProducts',
      href: '/all-products',
      icon: require('./../assets/monitoring.svg'),
    },
    {
      title: 'Fitness Products',
      titleId: 'navbar.link.fitnessProducts',
      href: '/all-products?type=fitness',
      icon: 'FitnessCenterIcon',
    },
    {
      title: 'Monitoring Equipments',
      titleId: 'navbar.link.monitoringEquipments',
      href: '/all-products?type=monitoring',
      icon: require('./../assets/monitoring.svg'),
    },
  ],
};
const LEARNING_CONFIG = {
  title: 'Learning',
  titleId: 'navbar.groupTitle.learning',
  pages: [
    {
      title: 'Yoga Articles',
      titleId: 'navbar.link.yogaArticles',
      href: '/articles?type=yoga',
      icon: 'ListAltOutlined',
    },
    {
      title: 'Gym Articles',
      titleId: 'navbar.link.gymArticles',
      href: '/articles?type=gym',
      icon: 'FitnessCenterIcon',
    },
    {
      title: 'All Articles',
      titleId: 'navbar.link.allArticles',
      href: '/articles',
      icon: 'ListAltOutlined',
    },
  ],
}
const MANAGEMENT_CONFIG = {
  title: 'Management',
  titleId: 'navbar.groupTitle.management',
  pages: [
    {
      title: 'Profile',
      titleId: 'navbar.link.profile',
      href: `/user/detail/${CURRENT_USER_ROUTE_UUID}`,
      icon: require('./../assets/profile.svg'),
    },
  ],
};
const MANAGEMENT_CONFIG_DEVICES = {
  ...MANAGEMENT_CONFIG,
  pages: [
    MANAGEMENT_CONFIG.pages[0],
    {
      title: 'Devices',
      titleId: 'navbar.link.devices',
      href: '/user/devices',
      icon: require('./../assets/devices.svg'),
    }
  ]
}
const MANAGEMENT_CONFIG_DEVICES_EDITOR = {
  ...MANAGEMENT_CONFIG,
  pages: [
    MANAGEMENT_CONFIG.pages[0],
    {
      title: 'Dashboard',
      titleId: 'navbar.link.dashboard',
      href: '/admin/dashboard',
      icon: require('./../assets/monitoring.svg'),
    },
    {
      title: 'Notifications',
      titleId: 'navbar.link.notifications',
      href: '/admin/notifications',
      icon: require('./../assets/notifications.svg'),
    }
  ]
}
const MANAGEMENT_CONFIG_GATEWAY_EDITOR = {
  ...MANAGEMENT_CONFIG,
  pages: [
    MANAGEMENT_CONFIG.pages[0],
    {
      title: 'Notifications',
      titleId: 'navbar.link.notifications',
      href: '/admin/notifications',
      icon: require('./../assets/notifications.svg'),
    }
  ]
}
const DEVICES_OVERVIEW_CONFIG = {
  title: 'Overview',
  titleId: 'navbar.groupTitle.overview',
  pages: [
    {
      title: 'Overview',
      titleId: 'navbar.link.overview',
      href: '/user/overview',
      icon: require('./../assets/overview.svg'),
    },
    {
      title: 'Monitoring/Graphs',
      titleId: 'navbar.link.monitoring',
      href: '/user/monitoring',
      icon: require('./../assets/monitoring.svg'),
    },
    {
      title: 'Notifications',
      titleId: 'navbar.link.notifications',
      href: '/user/notifications',
      icon: require('./../assets/notifications.svg'),
    },
    {
      title: 'Track Location',
      titleId: 'navbar.link.trackLocation',
      href: '/user/location',
      icon: require('./../assets/tracklocation.svg'),
    },
    {
      title: 'Watch Settings',
      titleId: 'navbar.link.watch.settings',
      href: '/user/settings',
      icon: require('./../assets/settings.svg')
    }
  ],
}
const OVERVIEW_CONFIG_GATEWAY = {
  title: 'Overview',
  titleId: 'navbar.groupTitle.overview',
  pages: [
    {
      title: 'Overview',
      titleId: 'navbar.link.overview',
      href: '/user/overview',
      icon: require('./../assets/overview.svg'),
    },
    {
      title: 'Notifications',
      titleId: 'navbar.link.notifications',
      href: '/user/notifications',
      icon: require('./../assets/notifications.svg'),
    }
  ],
};
const ALERTING_CONFIG = {
  title: 'Alerting',
  titleId: 'navbar.groupTitle.alerting',
  pages: [
    {
      title: 'Telegram',
      titleId: 'navbar.link.telegram',
      href: `/user/telegram`,
      icon: require('./../assets/profile.svg'),
    }
  ],
};
const TASKS_CONFIG = {
  title: 'Tasks',
  titleId: 'navbar.groupTitle.tasks',
  pages: [
    {
      title: 'Dashboard',
      titleId: 'navbar.link.tasks.dashboard',
      href: '/admin/task/dashboard',
      icon: require('./../assets/devices.svg'),
    },
    {
      title: 'Monitor',
      titleId: 'navbar.link.tasks.list',
      href: '/admin/task/list',
      icon: require('./../assets/devices.svg'),
    },
  ],
};
const DEVICES_CONFIG = {
  title: 'Devices',
  titleId: 'navbar.groupTitle.devices',
  pages: [
    {
      title: 'All Devices',
      titleId: 'navbar.link.allDevices',
      href: '/admin/devices',
      icon: require('./../assets/devices.svg'),
    },
    {
      title: 'Sold Devices',
      titleId: 'navbar.link.soldDevices',
      href: `/admin/devices/${IsSoldFilter}`,
      icon: require('./../assets/devices.svg'),
    },
    {
      title: 'UnSold Devices',
      titleId: 'navbar.link.unsoldDevices',
      href: `/admin/devices/${IsNotSoldFilter}`,
      icon: require('./../assets/devices.svg'),
    },
  ],
};
const CUSTOMERS_CONFIG = {
  title: 'Customers',
  titleId: 'navbar.groupTitle.customers',
  pages: [
    {
      title: 'All Customers',
      titleId: 'navbar.link.allCustomers',
      href: '/admin/users',
      icon: require('./../assets/profile.svg'),
    },
    {
      title: 'Active Customers',
      titleId: 'navbar.link.activeCustomers',
      href: `/admin/users/${isActiveFilter}`,
      icon: require('./../assets/profile.svg'),
    },
    {
      title: 'Inactive Customers',
      titleId: 'navbar.link.inactiveCustomers',
      href: `/admin/users/${inactiveFilter}`,
      icon: require('./../assets/profile.svg'),
    },
  ],
};
const COMPANY_CONFIG = {
  title: 'Company Management',
  titleId: 'navbar.groupTitle.companyManagement',
  pages: [
    {
      title: 'Company Details',
      titleId: 'navbar.link.companyDetails',
      href: `/admin/company/${CURRENT_USER_ROUTE_UUID}`,
      icon: require('./../assets/companies2.png'),
    },
    {
      title: 'All Branches',
      titleId: 'navbar.link.allBranches',
      href: '/admin/branches',
      icon: require('./../assets/companies.png'),
    },
  ],
};
const BRANCH_CONFIG = {
  title: 'Branch Management',
  titleId: 'navbar.groupTitle.branchManagement',
  pages: [
    {
      title: 'Branch Details',
      titleId: 'navbar.link.branchDetails',
      href: `/admin/branch/${CURRENT_USER_ROUTE_UUID}`,
      icon: require('./../assets/companies2.png'),
    },
  ],
};
const COMPANY_MANAGEMENT_CONFIG = {
  title: 'Company Management',
  titleId: 'navbar.groupTitle.companyManagement',
  pages: [
    {
      title: 'All Companies',
      titleId: 'navbar.link.allCompanies',
      href: '/admin/companies',
      icon: require('./../assets/companies.png'),
    },
    {
      title: 'All Branches',
      titleId: 'navbar.link.allBranches',
      href: '/admin/branches',
      icon: require('./../assets/companies2.png'),
    },
  ],
};
const SIMULATOR_CONFIG = {
  title: 'Simulator',
  titleId: 'navbar.groupTitle.simulator',
  pages: [
    {
      title: 'Simulator',
      titleId: 'navbar.link.simulator',
      href: '/admin/simulator',
      icon: require('./../assets/simulator-icon.jpeg'),
    },
  ],
};
const BLT_GATEWAY_CONFIG = {
  title: 'BLT Gateway',
  titleId: 'navbar.groupTitle.gateway',
  pages: [
    {
      title: 'Live Monitoring - Room View',
      titleId: 'navbar.link.live.monitoring.room.view',
      href: '/admin/gateway/roomViewInteractions',
      icon: require('./../assets/devices.svg'),
    },
    {
      title: 'Live Monitoring',
      titleId: 'navbar.link.live.monitoring',
      href: '/admin/gateway/interactions',
      icon: require('./../assets/devices.svg'),
    },
    {
      title: 'All Gateways',
      titleId: 'navbar.link.gateways.list',
      href: '/admin/gateway',
      icon: require('./../assets/devices.svg'),
    },
    {
      title: 'All Beacons',
      titleId: 'navbar.link.beacons.list',
      href: '/admin/beacons',
      icon: require('./../assets/devices.svg'),
    }
  ],
};

const BLT_GATEWAY_CONFIG_ADMIN = {
  ...BLT_GATEWAY_CONFIG,
  pages: [
    ...BLT_GATEWAY_CONFIG.pages,
    {
      title: 'Alert Logs',
      titleId: 'navbar.link.blt.alert.logs',
      href: '/admin/alertlogs',
      icon: require('./../assets/devices.svg'),
    }
  ],
};

export const GUEST_SIDE_MENU_OPTIONS = [
  PRODUCTS_CONFIG,
  LEARNING_CONFIG,
];

export const LOGGEDIN_GUEST_MENU_OPTIONS = [
  MANAGEMENT_CONFIG,
    PRODUCTS_CONFIG,
  LEARNING_CONFIG
];

export const USER_SIDE_MENU_OPTIONS = [
  DEVICES_OVERVIEW_CONFIG,
  MANAGEMENT_CONFIG_DEVICES,
  ALERTING_CONFIG
];

const MANAGER_SIDEBAR_OPTIONS = [
  MANAGEMENT_CONFIG_DEVICES_EDITOR,
  TASKS_CONFIG,
  DEVICES_CONFIG,
  CUSTOMERS_CONFIG,
  ALERTING_CONFIG,
  COMPANY_CONFIG
];

const SUPERVISOR_SIDEBAR_OPTIONS = [
  MANAGEMENT_CONFIG_DEVICES_EDITOR,
  TASKS_CONFIG,
  DEVICES_CONFIG,
  CUSTOMERS_CONFIG,
  ALERTING_CONFIG,
  BRANCH_CONFIG,
];

const ADMIN_SIDEBAR_OPTIONS = [
  MANAGEMENT_CONFIG_DEVICES_EDITOR,
  TASKS_CONFIG,
  DEVICES_CONFIG,
  CUSTOMERS_CONFIG,
  BLT_GATEWAY_CONFIG_ADMIN,
  ALERTING_CONFIG,
  COMPANY_MANAGEMENT_CONFIG,
  SIMULATOR_CONFIG,
];

const MONITOR_SIDEBAR_OPTIONS = [
  MANAGEMENT_CONFIG_GATEWAY_EDITOR,
  {
    ...BLT_GATEWAY_CONFIG,
    pages: [
      {
        ...BLT_GATEWAY_CONFIG.pages[0]
      },
      {
        ...BLT_GATEWAY_CONFIG_ADMIN.pages[4]
      }
    ]
  },
  ALERTING_CONFIG
]

const BRANCH_MONITOR_SIDEBAR_OPTIONS = [
  MANAGEMENT_CONFIG_GATEWAY_EDITOR,
  TASKS_CONFIG,
  {
    ...DEVICES_CONFIG,
    pages: [
      DEVICES_CONFIG.pages[0]
    ]
  },
  ALERTING_CONFIG
]

export const USERROLE_SIDEBAR_OPTIONS_MAP = {
  [USER_ROLES.ADMIN]: ADMIN_SIDEBAR_OPTIONS,
  [USER_ROLES.MANAGER]: MANAGER_SIDEBAR_OPTIONS,
  [USER_ROLES.SUPERVISOR]: SUPERVISOR_SIDEBAR_OPTIONS,
  [USER_ROLES.OWNER]: USER_SIDE_MENU_OPTIONS,
  [USER_ROLES.RELATIVE]: USER_SIDE_MENU_OPTIONS,
  [USER_ROLES.USER]: LOGGEDIN_GUEST_MENU_OPTIONS,
  [USER_ROLES.MONITOR]: SUPERVISOR_SIDEBAR_OPTIONS,
  [USER_ROLES.BRANCH_MONITOR]: BRANCH_MONITOR_SIDEBAR_OPTIONS,
  [USER_ROLES.COMPANY_MONITOR]: BRANCH_MONITOR_SIDEBAR_OPTIONS
};

export const GATEWAY_USER_SIDE_MENU_OPTIONS = [
  OVERVIEW_CONFIG_GATEWAY,
  MANAGEMENT_CONFIG,
  ALERTING_CONFIG
];

const GATEWAY_SUPERVISOR_SIDEBAR_OPTIONS = [
  MANAGEMENT_CONFIG_GATEWAY_EDITOR,
  BLT_GATEWAY_CONFIG_ADMIN,
  CUSTOMERS_CONFIG,
  ALERTING_CONFIG,
  BRANCH_CONFIG
];

const GATEWAY_MANAGER_SIDEBAR_OPTIONS = [
  MANAGEMENT_CONFIG_GATEWAY_EDITOR,
  BLT_GATEWAY_CONFIG_ADMIN,
  CUSTOMERS_CONFIG,
  ALERTING_CONFIG,
  COMPANY_MANAGEMENT_CONFIG
];

export const USERROLE_SIDEBAR_OPTIONS_GATEWAY_MAP = {
  [USER_ROLES.USER]: LOGGEDIN_GUEST_MENU_OPTIONS,
  [USER_ROLES.RELATIVE]: GATEWAY_USER_SIDE_MENU_OPTIONS,
  [USER_ROLES.OWNER]: GATEWAY_USER_SIDE_MENU_OPTIONS,
  [USER_ROLES.SUPERVISOR]: GATEWAY_SUPERVISOR_SIDEBAR_OPTIONS,
  [USER_ROLES.MANAGER]: GATEWAY_MANAGER_SIDEBAR_OPTIONS,
  [USER_ROLES.ADMIN]: ADMIN_SIDEBAR_OPTIONS,
  [USER_ROLES.MONITOR]: MONITOR_SIDEBAR_OPTIONS,
  [USER_ROLES.BRANCH_MONITOR]: LOGGEDIN_GUEST_MENU_OPTIONS,
  [USER_ROLES.COMPANY_MONITOR]: LOGGEDIN_GUEST_MENU_OPTIONS
}
